var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-primary-lighter",attrs:{"id":"wrapper"}},[_c('layout-header'),_vm._v(" "),_c('main',{staticClass:"content-wrapper"},[_c('nuxt')],1),_vm._v(" "),_c('layout-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }